export default "__VITE_ASSET__be94d5f7__"